import { useState, type FormEvent } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { authApi } from '../lib/domain';
import { ApiError } from '../lib/api';
import { useAuth } from '../lib/hooks';

export function LoginPage() {
  const { accessToken } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (accessToken) return <Navigate to="/lists" replace />;

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await authApi.login(email, password);
      navigate('/lists');
    } catch (err) {
      if (err instanceof ApiError) setError(err.message);
      else setError('Anmeldung ohne Internetverbindung ist nicht möglich.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="stack">
      <img src="/logo/logo.png" alt="Logo" style={{ display: 'block', margin: '0 auto', maxWidth: 160, height: 'auto' }} />
      <h1>Anmelden</h1>
      <form className="stack card" onSubmit={onSubmit}>
        <div className="field">
          <label htmlFor="email">E-Mail-Adresse</label>
          <input id="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="password">Passwort</label>
          <input id="password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {error && <p className="error-text" role="alert">{error}</p>}
        <button className="primary" type="submit" disabled={busy}>
          Anmelden
        </button>
      </form>
      <p>
        <Link to="/forgot-password">Passwort vergessen?</Link>
      </p>
      <p>
        Noch kein Konto? <Link to="/register">Registrieren</Link>
      </p>
    </div>
  );
}
